<template>
	<div>
		<div :style="{backgroundImage: 'url(' + topImage + ')',height: '300px', backgroundPosition: 'center center',backgroundRepeat: 'no-repeat',backgroundSize: 'cover'}">
		</div>
		<div style="margin-top:50px;margin-bottom:100px;margin-left:10%;">
			<span style="font-size: 40px;">
				<span style="color:#409EFF;"><span style="font-weight: bold;">联系方式</span></span>
				<span style="color:#909399;margin-left:20px">CONTACT US</span>
			</span>
			<div style="width: 160px;height: 7px;background-color: #409EFF;margin-top:20px;"></div>
			<div style="height: auto;margin-top:50px;padding-top:50px;padding-bottom:50px;">
				<el-image :src="mapImage" style="width: 35%; height: auto;vertical-align: top;" fit="contain">
					<div slot="placeholder" style="text-align:center;padding-top:30%;font-size:12px;color:#909399;">
					  加载中...
					</div>
				</el-image>
				<div style="display: inline-block;width: 58%;height: auto;margin-left: 4%;">
					<div style="height: auto;line-height: 50px;font-size:18px;margin-bottom: 50px;">
						<i class="el-icon-location-outline" style="font-size: 30px;margin-right: 10px;font-weight: bold;color:#409EFF;position: relative;top:5px;ver"></i>
						{{contact.address}}
					</div>
					<div style="height: auto;line-height: 50px;font-size:18px;margin-bottom: 50px;">
						<i class="el-icon-phone-outline" style="font-size: 30px;margin-right: 10px;font-weight: bold;color:#409EFF;position: relative;top:5px;"></i>
						{{contact.phone}}
					</div>
					<div style="height: auto;line-height: 50px;font-size:18px;">
						<i class="el-icon-bangzhu" style="font-size: 30px;margin-right: 10px;font-weight: bold;color:#409EFF;position: relative;top:5px;"></i>
						{{contact.url}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import utils from '@/utils';
	export default {
		name: 'ContactUs',
		data() {
			return {
				topImage:utils.fileUrl()+'contactUs/topImage.jpg',
				mapImage:utils.fileUrl()+'contactUs/map.png',
				contact:{
					address:"贵州省贵阳市贵安新区黔中大道电子信息产业园孵化园6栋4楼",
					phone:"0851-88926277",
					url:"http://www.qamltech.com",
				},
				
			}
		},
		computed: {

		},
		components: {},
		methods: {
		},
		mounted() {
			
		}

	}
</script>

<style>
</style>